export default __webpack_public_path__ + "static/media/Image4.0172a172.jpeg";